<template>
  <div>
    <div class="topFloor-page">
      <!-- <div class="aite_title">
        <div class="lef">
          <span>您好，欢迎来到</span>
          <span class="aite">艾特企业服务平台</span>
          <span class="aite">登录</span>
          <span class="aite">注册</span>
        </div>
        <div class="rig">
          <div class="ki">
            <span>手机商城</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>会员中心</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>购物车</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>我的订单</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>我的收藏</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>商家中心</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>客户服务</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
          <div class="ki">
            <span>网站导航</span>
            <i class="el-icon-arrow-down" size="12"></i>
          </div>
        </div>
      </div> -->
      <div class="search">
        <div class="logo" @click="goHome">
          <img src="../../assets/img/aiteLogo.png" alt />
        </div>
        <div class="input">
          <div class="ipt">
            <el-input
              placeholder="请输入您要搜索的商品关键字"
              v-model="input3"
              class="input-with-select"
              style="width= 32px;"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchKey"></el-button>
            </el-input>
          </div>
        </div>
        <div class="photo">
          <img src="http://aite.cnaite.cn/data/upload/shop/adv/06413878001432594.png" alt />
        </div>
      </div>
    </div>
    <Tabbar :tabIndexs="indexs"></Tabbar>
  </div>
</template>
<script>
import Tabbar from "./Tabbar";
export default {
  data() {
    return {
      input3: "",
      indexs:true
    };
  },
  components: {
    Tabbar
  },
  methods:{
    searchKey(){
      this.$emit('keySearch',this.input3)
    },
    goHome(){
      this.indexs = !this.indexs;
      this.$router.push({path:'/'});
    }
  }
};
</script>
<style scoped lang="scss">
.topFloor-page {
  width: 1200px;
  height: auto;
  margin: auto;
}
.aite_title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
}
.lef {
  font-size: 12px;
}
.aite {
  color: #3091f2;
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
}
.rig {
  display: flex;
}
.ki {
  width: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
}
.ki > span {
  color: #777;
  font-size: 14px;
}
.search {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .input {
    width: 550px;
    .ipt {
      border: 2px solid #3091f2;
    }
  }
}
el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
/deep/ .el-input__inner {
  border: 0;
}
</style>